import * as React from "react";
import { Route, Routes } from "react-router-dom";

import { ErrorHandler, pageNotFound } from "lib/errorHandler";
import { Page } from "lib/page";

import { PatientProvider } from "./context";
import { CreatePatientPage } from "./createPatient";
import { IssueDevice, WithdrawDevice } from "./device";
import { UpdatePatientPage } from "./editPatient";
import { PatientPage } from "./patient";
import { PatientsPage } from "./patients";
import { SearchPage } from "./search";

export const PatientsIndex: React.FC = () => {
  return (
    <Routes>
      {pageNotFound}
      <Route index element={<Page element={<PatientsPage />} />} />
      <Route path="search" element={<Page element={<SearchPage />} />} />
      <Route path="add/*" element={<Page element={<CreatePatientPage />} />} />
      <Route
        path=":id/*"
        element={
          <ErrorHandler>
            <PatientProvider>
              <Routes>
                {pageNotFound}
                <Route index element={<PatientPage />} />
                <Route path="edit/*" element={<UpdatePatientPage />} />
                <Route path="issue-device/*" element={<IssueDevice />} />
                <Route path="withdraw-device/*" element={<WithdrawDevice />} />
              </Routes>
            </PatientProvider>
          </ErrorHandler>
        }
      />
    </Routes>
  );
};
